<template>
  <div>
    <div class="mx-5">
      <v-alert
        v-model="toAlert"
        type="warning"
        icon="mdi-alert-circle-outline"
        dense
      >
        <p class="text-subtitle-2">
          This module is currently in beta testing phase. Access is limited to
          selected users only.
        </p>
      </v-alert>
    </div>
    <v-row class="space-y-10">
      <v-spacer></v-spacer>
      <v-col cols="12" md="4" class="d-flex justify-space-between">
        <v-text-field
          v-model="search"
          outlined
          dense
          hide-details
          prepend-inner-icon="search"
          label="Search"
          class="search-input mr-3"
        />
     <v-btn
          class="btn-save"
          :color="$vuetify.theme.themes.light.submitBtns"
          v-if="tab == 1"
          @click="add()"
        >
          Add OPCR
        </v-btn> 
      </v-col>
    </v-row>
    <v-card class="dt-container" elevation="0" outlined>
      <v-data-table
        :headers="tab == 2 ? headers2 : headers"
        :items="data"
        :items-per-page="10"
        :search="search"
        :options.sync="options"
        :loading="loading"
        @pagination="pagination"
        hide-default-footer
        class="text-body-2"
      >
        <template v-slot:[`item.approvals`]="{ item }">
          <div
            class="mx-auto"
            :class="
              $vuetify.breakpoint.xl
                ? 'xl_lg_width'
                : $vuetify.breakpoint.lg
                ? 'xl_lg_width'
                : $vuetify.breakpoint.md
                ? 'md_width'
                : 'sm_width'
            "
          >
            <!-- TARGETS -->
            <v-row no-gutters align="start" class="mb-3 pa-2">
              <v-col cols="4">
                <span class="font-weight-bold">TARGETS</span>
              </v-col>

              <v-col cols="8">
                <template v-if="item.target_submission.is_submitted == 0">
                  <div class="text-right">
                    <v-chip x-small class="pa-2 ml-4"> For Submission </v-chip>
                  </div>
                </template>

                <template v-else>
                  <v-row
                    v-for="(i, idx) in setTargetApproval(item)"
                    :key="idx"
                    no-gutters
                    align="center"
                    class="mb-1"
                  >
                    <v-col cols="6"> {{ i.type }}: </v-col>

                    <v-col cols="6" class="text-right">
                      <v-chip
                        x-small
                        class="pa-2 ml-4"
                        :class="i.color"
                        :color="i.chip"
                      >
                        {{ i.status }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>

            <!-- ACCOMPLISHMENT -->
            <v-row no-gutters align="start" v-if="false">
              <v-col cols="4">
                <span class="font-weight-bold">ACCOMPLISHMENT:</span>
              </v-col>

              <v-col cols="8">
                <template
                  v-if="item.accomplishment_submission.is_submitted == 0"
                >
                  <div class="text-right">
                    <v-chip x-small class="pa-1"> For Submission </v-chip>
                  </div>
                </template>

                <template v-else>
                  <v-row
                    v-for="(i, idx) in setAccomplishmentApproval(item)"
                    :key="idx"
                    no-gutters
                    align="center"
                    class="mb-2"
                  >
                    <v-col cols="6"> {{ i.type }}: </v-col>

                    <v-col cols="6" class="text-right">
                      <v-chip
                        x-small
                        class="pa-1"
                        :class="i.color"
                        :color="i.chip"
                      >
                        {{ i.status }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>
          </div>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <div class="button-group pa-2">
            <v-btn
              v-if="!item.isWorkback"
              class="global-btn-save"
              @click="viewItem(item)"
            >
              Targets
            </v-btn>
            <!-- <v-btn
              v-if="!item.isWorkback"
              class="global-btn-save"
              @click="addAccomplishment(item)"
            >
              Accomplishment</v-btn
            > -->
            <!-- <v-btn
              v-if="!item.isWorkback"
              class="global-btn-save"
              @click="viewSummary(item)"
            >
              Summary</v-btn
            > -->
            <v-btn
              v-if="!item.isWorkback"
              class="global-btn-save"
              @click="viewOPCR(item)"
              >OPCR Report</v-btn
            >

            <v-btn
              v-if="item.isWorkback"
              @click="viewFile(item)"
              class="global-btn-save"
              >Workback File</v-btn
            >

            <!-- <v-btn
            class="my-1"
            block
            x-small
            @click="deleteItem(item)"
            outlined
            color="red"
            >Delete</v-btn
          > -->
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-row class="mt-4" align="center">
      <v-col cols="12" md="4" class="d-flex align-center">
        <span class="pagination-label mr-2">Show</span>

        <v-select
          dense
          outlined
          hide-details
          :value="options.itemsPerPage"
          :items="perPageChoices"
          class="per-page-select"
          @change="options.itemsPerPage = parseInt($event, 10)"
        />

        <span class="pagination-label ml-2">entries</span>
      </v-col>

      <v-col cols="12" md="4" class="text-center pagination-info">
        Showing
        <strong>{{ paginationData.pageStart + 1 }}</strong>
        -
        <strong>{{ paginationData.pageStop }}</strong>
        of
        <strong>{{ paginationData.itemsLength }}</strong>
        entries
      </v-col>

      <v-col cols="12" md="4" class="d-flex justify-end">
        <v-pagination
          v-model="options.page"
          :length="paginationData.pageCount"
          :total-visible="5"
          color="#147452"
          class="modern-pagination"
        />
      </v-col>
    </v-row>

    <!-- delete dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
          Are you sure you want to proceed?
        </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()"> Close </v-btn>
          <v-btn color="green" class="white--text" @click="confirmDelete()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <OPCRDialog :data="itemData" :action="action" />
    <OPCRTargetDialog :data="opcrData" :action="action" />
    <OPCRSummaryDialog :data="opcrSumData" />
    <RateOPCRTargetDialog :data="rateOpcr" />
    <ViewOPCRDialog :data="opcr" />

    <!-- <IPCRSupportDialog :data="supportData" />
    <ViewIPCRDialog :data="ipcr" /> -->

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="5000"
    ></fade-away-message-component>
  </div>
</template>
<script>
// import icon from "@/assets/icon.vue";
export default {
  components: {
    OPCRDialog: () =>
      import("../../components/Dialogs/Forms/OPCR/OPCRDialog.vue"),
    OPCRTargetDialog: () =>
      import("../../components/Dialogs/Forms/OPCR/OPCRTargetDialog.vue"),
    OPCRSummaryDialog: () =>
      import("../../components/Dialogs/Forms/OPCR/OPCRSummaryDialog.vue"),
    RateOPCRTargetDialog: () =>
      import("../../components/Dialogs/Forms/OPCR/RateOPCRTargetDialog.vue"),
    ViewOPCRDialog: () =>
      import("../../components/Dialogs/Forms/OPCR/ViewOPCRDialog.vue"),
    // icon,
    // ViewIPCRFunctionDialog: () =>
    //   import("../Dialogs/Views/ViewIPCRFunctionDialog.vue"),

    // MPORDialog: () => import("../../components/Dialogs/Forms/MPORDialog.vue"),
    // IPCRSupportDialog: () =>
    //   import("../../components/Dialogs/Forms/IPCRSupportDialog.vue"),
  },
  data: () => ({
    toAlert: false,
    confirmDialog: false,
    itemToDelete: null,
    search: "",
    fullname: null,
    applicantData: null,
    itemData: null,
    taggingData: null,
    opcrData: null,
    supportData: null,
    rateOpcr: null,
    headers: [
      {
        text: "Year",
        value: "year",
        align: "start",
        valign: "center",
        sortable: false,
      },

      {
        text: "Approvals",
        value: "approvals",
        align: "center",
        valign: "center",
        sortable: false,
      },

      // {
      //   text: "Assess",
      //   value: "assesed_by_status",
      //   align: "center",
      //   valign: "center",
      //   sortable: false,
      // },
      // {
      //   text: "Final Rater",
      //   value: "final_rating_by_status",
      //   align: "center",
      //   valign: "center",
      //   sortable: false,
      // },
      {
        text: "Action",
        value: "action",
        align: "center",
        width: 100,
        valign: "center",
        sortable: false,
      },
    ],

    data: [],
    periodList: [
      {
        id: 1,
        description: "January to June",
      },
      {
        id: 2,
        description: "July to December",
      },
      {
        id: 3,
        description: "January to December",
      },
    ],

    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    activeTab: { id: 1, name: "Active-Jobs" },
    tab: 1,
    tabList: [
      //   { id: 1, name: "Target" },
      //   { id: 2, name: "Tagged Employees" },
      //   { id: 3, name: "Applicants" },
    ],
    mporData: null,
    opcr: null,
    opcrSumData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
    yearList: [],
  }),

  mounted() {
    this.eventHub.$on("closeOPCRDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeOPCRTargetDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeOPCRSummaryDialog", () => {
      this.initialize();
    });

    this.eventHub.$on("closeRateOPCRTargetDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeViewOPCRDialog", () => {
      this.initialize();
    });
    // this.eventHub.$on("closeIPCRSupportDialog", () => {
    //   this.initialize();
    // });
    // this.eventHub.$on("closeViewIPCRDialog", () => {
    //   this.initialize();
    // });
  },

  beforeDestroy() {
    this.eventHub.$off("closeOPCRDialog");
    this.eventHub.$off("closeOPCRTargetDialog");
    this.eventHub.$off("closeOPCRSummaryDialog");
    this.eventHub.$off("closeRateOPCRTargetDialog");
    this.eventHub.$off("closeViewOPCRDialog");
    // this.eventHub.$off("closeIPCRSupportDialog");
    // this.eventHub.$off("closeViewIPCRDialog");
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    filterYear: {
      handler(newData, oldData) {
        if (oldData != newData) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
  computed: {
    filterYear() {
      return this.$store.getters.getFilterSelected;
    },
    isBetaTester() {
      let arr = [
        "86",
        "631",
        "417",
        "287",
        "50",
        "215",
        "306",
        "652",
        "215",
        "67",
      ];

      return arr.includes(this.$store.state.user.id);
    },
  },
  methods: {
    getPeriodDescription(id) {
      for (let i = 0; i < this.periodList.length; i++) {
        if (this.periodList[i].id == id) {
          return this.periodList[i].description;
        }
      }
    },
    pagination(data) {
      this.paginationData = data;
    },

    initialize() {
      this.axiosCall("/opcr/getMy", "GET").then((res) => {
        if (res) {
          console.log("YYYYYY", res.data);
          this.data = res.data;
          this.loading = false;
        }
      });
    },

    setTargetApproval(item) {
      let imm_head = {
        type: "Immediate Head",
        status: "For Approval",
        color: "",
        chip: null,
      };
      let planning = { type: "Planning", status: "-", color: "", chip: null };
      let cpmt_mem = {
        type: "CPMT Member",
        status: "-",
        color: "",
        chip: null,
      };
      let cpmt_head = { type: "CPMT Head", status: "-", color: "", chip: null };
      let president = { type: "President", status: "-", color: "", chip: null };

      if (item) {
        imm_head.status = this.getApprovalStatus(
          item.target_submission.imm_approval_status,
        ).sts;
        imm_head.color = this.getApprovalStatus(
          item.target_submission.imm_approval_status,
        ).fontColor;
        imm_head.chip = this.getApprovalStatus(
          item.target_submission.imm_approval_status,
        ).chip;
        planning.status = this.getApprovalStatus(
          item.target_submission.planning_user_approval_status,
        ).sts;
        planning.color = this.getApprovalStatus(
          item.target_submission.planning_user_approval_status,
        ).fontColor;
        planning.chip = this.getApprovalStatus(
          item.target_submission.planning_user_approval_status,
        ).chip;
        cpmt_mem.status = this.getApprovalStatus(
          item.target_submission.cpmt_approval_status,
        ).sts;
        cpmt_mem.color = this.getApprovalStatus(
          item.target_submission.cpmt_approval_status,
        ).fontColor;
        cpmt_mem.chip = this.getApprovalStatus(
          item.target_submission.cpmt_approval_status,
        ).chip;
        cpmt_head.status = this.getApprovalStatus(
          item.target_submission.cpmt_head_approval_status,
        ).sts;
        cpmt_head.color = this.getApprovalStatus(
          item.target_submission.cpmt_head_approval_status,
        ).fontColor;
        cpmt_head.chip = this.getApprovalStatus(
          item.target_submission.cpmt_head_approval_status,
        ).chip;
        president.status = this.getApprovalStatus(
          item.target_submission.president_approval_status,
        ).sts;
        president.color = this.getApprovalStatus(
          item.target_submission.president_approval_status,
        ).fontColor;
        president.chip = this.getApprovalStatus(
          item.target_submission.president_approval_status,
        ).chip;
      }

      // return [imm_head, planning, cpmt_mem, cpmt_head, president];
      return [imm_head, planning, cpmt_mem, president];
    },
    setAccomplishmentApproval(item) {
      let imm_head = {
        type: "Immediate Head",
        status: "For Approval",
        color: "",
        chip: null,
      };
      let planning = { type: "Planning", status: "-", color: "", chip: null };
      let cpmt_mem = {
        type: "CPMT Member",
        status: "-",
        color: "",
        chip: null,
      };
      let cpmt_head = { type: "CPMT Head", status: "-", color: "", chip: null };
      let president = { type: "President", status: "-", color: "", chip: null };

      if (item) {
        imm_head.status = this.getApprovalStatus(
          item.accomplishment_submission.imm_approval_status,
        ).sts;
        imm_head.color = this.getApprovalStatus(
          item.accomplishment_submission.imm_approval_status,
        ).fontColor;
        imm_head.chip = this.getApprovalStatus(
          item.accomplishment_submission.imm_approval_status,
        ).chip;
        planning.status = this.getApprovalStatus(
          item.accomplishment_submission.planning_user_approval_status,
        ).sts;
        planning.color = this.getApprovalStatus(
          item.accomplishment_submission.planning_user_approval_status,
        ).fontColor;
        planning.chip = this.getApprovalStatus(
          item.accomplishment_submission.planning_user_approval_status,
        ).chip;
        cpmt_mem.status = this.getApprovalStatus(
          item.accomplishment_submission.cpmt_approval_status,
        ).sts;
        cpmt_mem.color = this.getApprovalStatus(
          item.accomplishment_submission.cpmt_approval_status,
        ).fontColor;
        cpmt_mem.chip = this.getApprovalStatus(
          item.accomplishment_submission.cpmt_approval_status,
        ).chip;
        cpmt_head.status = this.getApprovalStatus(
          item.accomplishment_submission.cpmt_head_approval_status,
        ).sts;
        cpmt_head.color = this.getApprovalStatus(
          item.accomplishment_submission.cpmt_head_approval_status,
        ).fontColor;
        cpmt_head.chip = this.getApprovalStatus(
          item.accomplishment_submission.cpmt_head_approval_status,
        ).chip;
        president.status = this.getApprovalStatus(
          item.accomplishment_submission.president_approval_status,
        ).sts;
        president.color = this.getApprovalStatus(
          item.accomplishment_submission.president_approval_status,
        ).fontColor;
        president.chip = this.getApprovalStatus(
          item.accomplishment_submission.president_approval_status,
        ).chip;
      }

      // return [imm_head, planning, cpmt_mem, cpmt_head, president];
      return [imm_head, planning, cpmt_mem, president];
    },

    getApprovalStatus(val) {
      let chip;
      let sts;
      let fontColor;

      if (val == 3) {
        fontColor = "white--text";
        sts = "Pending";
        chip = "red";
      } else if (val == 2) {
        chip = "green";
        fontColor = "white--text";
        sts = "Approved";
      } else {
        fontColor = "";
        chip = "";
        sts = val == 1 ? "For Approval" : "-";
      }

      return {
        fontColor,
        sts,
        chip,
      };
    },

    //  getTargetsStatus(item) {
    //   let chip;
    //   let sts;
    //   let fontColor;
    //   if (item.isSubmitted == 0) {
    //     chip = "";
    //     fontColor = "";
    //     sts = "For Submission";
    //   } else {
    //     if (item.assesed_by_status == 3) {
    //       fontColor = "white--text";
    //       sts = "Pending";
    //       chip = "red";
    //     } else if (item.assesed_by_status == 2) {
    //       chip = "green";
    //       fontColor = "white--text";
    //       sts = "Approved";
    //     } else {
    //       fontColor = "";
    //       chip = "";
    //       sts = item.assesed_by_status == 1 ? "For Approval" : "For Submission";
    //     }
    //   }
    //   return {
    //     status: item.assesed_by_status,
    //     chip,
    //     fontColor,
    //     sts,
    //     isSubmitted: item.isSubmitted,
    //   };
    // },

    getStatus(type, item) {
      let chip;
      let sts;
      let fontColor;
      if (type == "assess") {
        if (item.isSubmitted == 0) {
          chip = "";
          fontColor = "";
          sts = "For Submission";
        } else {
          if (item.assesed_by_status == 3) {
            fontColor = "white--text";
            sts = "Pending";
            chip = "red";
          } else if (item.assesed_by_status == 2) {
            chip = "green";
            fontColor = "white--text";
            sts = "Approved";
          } else {
            fontColor = "";
            chip = "";
            sts =
              item.assesed_by_status == 1 ? "For Approval" : "For Submission";
          }
        }
      } else if (type == "final_rating") {
        if (item.isSubmitted == 0) {
          chip = "";
          fontColor = "";
          sts = "For Submission";
        } else {
          if (item.final_rating_by_status == null) {
            chip = "";
            fontColor = "";
            sts = "For Submission";
          } else if (item.final_rating_by_status == 1) {
            chip = "";
            fontColor = "";
            sts = "For Approval";
          } else if (item.final_rating_by_status == 2) {
            chip = "green";
            fontColor = "white--text";
            sts = "Approved";
          } else if (item.final_rating_by_status == 3) {
            fontColor = "white--text";
            sts = "Pending";
            chip = "red";
          }
        }
      }
      return {
        status: item.assesed_by_status,
        chip,
        fontColor,
        sts,
        isSubmitted: item.isSubmitted,
      };
    },

    changeTab(tab) {
      this.activeTab = tab;

      // if (tab.id == 1) {

      this.tab = tab.id;
      this.initialize();
      // } else if (tab.id == 2) {
      //   this.getVerifiedUsers();
      //   this.tab = tab.id;
      // }
    },
    add() {
      this.itemData = { id: null };
      this.action = "Add";
    },

    viewMPOR(item) {
      if (item.targetCount > 0) {
        this.mporData = item;
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "No Targets Found!";
      }

      // this.action = "Update";
    },
    viewSummary(item) {
      this.opcrSumData = item;
    },

    viewOPCR(item) {
      this.opcr = item;
    },

    addAccomplishment(item) {
      this.rateOpcr = item;
    },
    viewItem(item) {
      this.opcrData = item;
      // this.action = "Update";
    },

    viewFile(item) {
      let url =
        process.env.VUE_APP_SERVER + "/opcr/previewFile/" + item.filename;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    viewSupport(item) {
      this.supportData = item;
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    confirmDelete() {
      console.log("DELETE ITEM", this.itemToDelete);
      // this.axiosCall("/ipcr/" + this.itemToDelete.id, "DELETE").then((res) => {
      //   if (res.data.status == 200) {
      //     this.confirmDialog = false;
      //     this.fadeAwayMessage.show = true;
      //     this.fadeAwayMessage.type = "success";
      //     this.fadeAwayMessage.header = "System Message";
      //     this.fadeAwayMessage.message = res.data.msg;
      //     this.initialize();
      //   } else {
      //     this.fadeAwayMessage.show = true;
      //     this.fadeAwayMessage.type = "error";
      //     this.fadeAwayMessage.header = "System Message";
      //     this.fadeAwayMessage.message = res.data.msg;
      //   }
      // });
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },
  },
};
</script>
<style scoped>
.xl_lg_width {
  width: 50%;
}
.md_width {
  width: 75%;
}
.sm_width {
  width: 100%;
}
</style>
